'use strict';

export default class errorsHighlight {
    constructor(options) {
        this.opt = options;
        this.bindHandlers();
    }

    bindHandlers() {
        $(document).ready(function () {

            let errors = $("div.form-error");
            if (errors.length > 0) {

                let firstError = errors.first();
                let elemToScroll = firstError.parent('div').length > 0 ?
                    firstError.parent('div') :  firstError.parent('label');

                $([document.documentElement, document.body]).animate({
                    scrollTop: elemToScroll.offset().top - 200
                }, 1000);
            }
        });
    }
}